<template>
  <div class="diadin">
   <div style="display: flex;justify-content: space-between;">
     <div style="width:64%;border: 1px solid #f2f2f2; border-radius: 5px;box-sizing: border-box;padding: 0 10px 10px 10px;box-shadow: 2px 2px #f9f9f9;">
      <div class="title">
      <div class="title_1">{{ $t('menu.Basicinformation') }}</div>
    </div>
    <div class="cont">
      <div class="contbox">
        <div class="conttitle">{{ $t('menu.OrderNo') }}</div>
        <div>{{ mation[0].po.orderNumber }}</div>

      </div>
    

      <div class="contbox">
        <div class="conttitle">{{ $t('menu.State') }}</div>
        <div>{{ formatStatus(mation[0].po.status) }} </div>
      </div>

      <div class="contbox">
        <div class="conttitle">{{ $t('menu.Distributor') }}</div>
        <div>{{ mation[0].po.dealerName }}</div>
      </div>
      <div class="contbox">
        <div class="conttitle">{{ $t('menu.OrderAmount') }}</div>
        <div style="display: flex;">{{ mation[0].po.orderAmount }} <p style="margin-left: 10px;">{{
          mation[0].po.currencyType }}</p>
        </div>
      </div>
      <div class="contbox">
        <div class="conttitle">{{ $t('menu.Paymentmethod') }}</div>
        {{ jstype(mation[0].po.paymentMethod) }}
        <div>

        </div>
      </div>
      <!-- <div class="contbox">
        <div class="conttitle" >价格条款</div>
        <div>
          {{ mation[0].po.priceTerms }}
        </div>
      </div> -->






    

      

      <div class="contbox">
        <div class="conttitle">{{ $t('menu.FreightMode') }}</div>
        <div>
          {{ formatHy(mation[0].po.shippingMethod) }}
        </div>
      </div>

      <div class="contbox">
        <div class="conttitle">{{ $t('menu.ExpectedShippingdate') }}</div>
        <div>
          {{ formatTime(mation[0].po.shippingDate) }}
          <!-- {{ mation[0].po.shippingDate }} -->
        </div>
      </div>




      <!-- <div class="contbox" style="width: 85%">
        <div class="conttitle" >收货地址</div>
        <div>{{ mation[0].po.address }}</div>
      </div> -->
      <div class="contbox" style="width: 85%;">
        <div class="conttitle">{{ $t('menu.Remarks') }}</div>
        <div style="width: 100%;">
          {{ mation[0].po.userRemarks }}
        </div>
      </div>
      <div class="contbox" style="width: 85%;" v-if="mation[0].po.status==-2">
        <div class="conttitle">{{ $t('menu.Remarksaa') }}</div>
        <div style="width: 100%;">
          {{ mation[0].po.remarks }}
        </div>
      </div>
    </div>
   
   </div>
     <div  style="width: 35%;border: 1px solid #f2f2f2; border-radius: 5px;box-sizing: border-box;padding: 0 10px 10px 10px;box-shadow: 2px 2px #f9f9f9;">
      <div class="title">
      <div class="title_1">{{ $t('menu.Basicinformation') }}</div>
    </div>
  
    <div >
        <div class="contddt">
          <div class="conttitle">{{ $t('menu.PurchaseAmount') }}</div>
          <div> {{ mation[0].po.orderAmount }}  {{ ctype(mation[0].po.accTypeId) }}</div>
        </div>
      <div class="contddt">
        <div class="conttitle">{{ $t('menu.yueikou') }}</div>
          <div v-if="mation[0].po.discountAmount!==null">
            {{ mation[0].po.discountAmount }} {{ ctype(mation[0].po.accTypeId) }}
          </div>
          <div v-else>
           0
          </div>
        </div>
         <div class="contddt">
           <div class="conttitle">{{ $t('menu.zhuanggjine') }}</div>
           <div v-if="mation[0].po.discountAmount!==null">
            {{ ccbaopl(mation[0].po.orderAmount-mation[0].po.discountAmount) }} {{ ctype(mation[0].po.accTypeId) }}
          </div>
          <div v-else>
          {{ mation[0].po.orderAmount }} {{ ctype(mation[0].po.accTypeId) }}
          </div>
         </div>

      <div class="contddt">
        <div class="conttitle">{{ $t('menu.OrderAmount') }}</div>
        <div style="display: flex;">{{ mation[0].po.orderAmount }}  {{ ctype(mation[0].po.accTypeId) }}
        </div>
      </div>
      <div class="contddt" style="border-top: 1px solid #f2f2f2;"> </div>
      <div class="contddt">
        <div class="conttitle">{{ $t('menu.yijiesuanjine') }}</div>
        <div style="color: #40d311;">
          {{  mation[0].po.settleAmount?  mation[0].po.settleAmount:0 }}   {{ ctype( mation[0].po.accTypeId) }}
        </div>
       
      </div>
 
     <div class="contddt">
        <div class="conttitle">{{ $t('menu.daijinsuanjin') }}</div>
        <div style="color: #ff2525;">
          {{ ccbaopl(mation[0].po.orderAmount-mation[0].po.discountAmount)-mation[0].po.settleAmount}}   {{ ctype(mation[0].po.accTypeId) }}
        </div>
      </div>
    </div>
   
   </div>
   </div>
  
    <div class="title" style="margin-bottom: 20px; justify-content: left">
      <div class="title_1">
        {{ $t('menu.ProductDetails') }}
      </div>
    </div>


    <div>
      <el-table  empty-text=" " :data="mation[0].poParts" style="width: 100%" stripe border highlight-current-row
        :cell-style="cellStyle">
        <el-table-column prop="itemNum" :label="$t('menu.ItemNo')" width="80"></el-table-column>
        <el-table-column prop="partNumber" :label="$t('menu.PartCode')" width="180"></el-table-column>
        <el-table-column prop="partName" :label="$t('menu.PartName')" width="280">
          <template slot-scope="scope">
            <div>{{ inle == 'zh' ? scope.row.partName : scope.row.partNameEn }}</div>
          </template>
        </el-table-column>
        
        <el-table-column prop="motorName" :label="$t('menu.VehicleModel')" width="150">
          <template slot-scope="scope">
            {{ inle == 'zh' ? scope.row.motorName : scope.row.motorNameEn }}
          </template>
        </el-table-column>
        <el-table-column prop="unitPrice" :label="$t('menu.UnitPrice')" width="130"></el-table-column>
          <el-table-column prop="discountUnitPrice" :label="$t('menu.zhekoudanjia')" width="130"></el-table-column>
   
        <el-table-column prop="quantity" :label="$t('menu.Quantity')" width="150">
          <!-- <template slot-scope="scope">
            {{scope.row.zt|sellstatus}}
          </template> -->
        </el-table-column>

        <el-table-column prop="amount" :label="$t('menu.SubTotal')" width="150">
        </el-table-column>
         <el-table-column prop="discountAmount" :label="$t('menu.zhekoujine')" width="130"></el-table-column>
        <el-table-column prop="xs" :label="$t('menu.DeliveryProgress')">
          <template slot-scope="scope">
            {{ scope.row.shippedQuantity }}/{{ scope.row.quantity }}
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="product-box">
      <!-- <div class="status">{{ formatStatus(mation[0].po.status) }}</div>
      <div class="status">商品：{{ mation[0].poParts.length }}</div>
      <div class="status">数量：{{ total }}</div> -->
      <!-- <div class="daochu" @click="exportDetails">{{ $t('menu.Export') }}</div> -->
    </div>

    <div class="agian">
      <el-button v-if="mation[0].po.status == -2 || mation[0].po.status == -1" type="primary" @click="gotoEdit(1)">{{
        $t('menu.Reapply') }}</el-button>
      <!-- <el-button @click="handleEdit">返回</el-button> -->
    </div>



    <div v-if="type==2">
       <div class="title" style="margin-bottom: 20px; justify-content: left">
      <div class="title_1">
       {{ $t('menu.OperationRecord')}}
      </div>
    </div>
  <div>
      <el-table  empty-text=" " :data="mation[0].poOperationLogs" style="width: 100%" stripe border highlight-current-row
        :cell-style="cellStyle">
        <el-table-column prop="actionTime" :label="$t('menu.Time')" width="180"></el-table-column>
        <el-table-column prop="actionEvent" :label="$t('menu.OperationContent')" width="180"></el-table-column>
        <el-table-column prop="remarks" :label="$t('menu.Remarks')" width="280">    </el-table-column>
        
        <el-table-column prop="actionUserName" :label="$t('menu.Operator')" width="150"> </el-table-column>
       

      </el-table>
    </div>
    </div>



    <div class="btn-box" v-if="mation[0].po.status == 1">
      <div class="btn blue" @click="openClosePop">{{ $t('menu.Cancel') }}</div>
      <div class="btn blue" @click="gotoEdit(2)">{{ $t('menu.Modify') }}</div>
       <div class="btn blue" v-if="tup!=='2'" @click="openClosePopa">{{ $t('menu.tgl') }}</div>
       <div class="btn blue" v-if="tup!=='2'" @click="openClosePopb">{{ $t('menu.jul') }}</div>
     
      <div class="btn" v-if="mation[0].po.status != 1" @click="goBack">{{ $t('menu.fanhui') }}</div>
    </div>
    <div class="btn-box" v-if="mation[0].po.status == 2">
      <div class="btn blue" @click="openClosePopaca">{{ $t('menu.quxiaofahuoo') }}</div>
      
     
    </div>
    <div class="btn-box" v-if="tup!=='2'">
      <div class="btn blue" v-if="mation[0].po.status==5" @click="erpzd( mation[0])">{{ $t('menu.erpzd') }}</div>
       <!-- <el-button  size="mini" v-if="mation[0].po.status!==1&& mation[0].po.status!==-1&&mation[0].po.status!==-2" @click="erpzd( mation[0])">{{
            $t('menu.erpzd') }}</el-button> -->
    </div>

    <div v-if="mation[0].po.status == 3 || mation[0].po.status == 4">
      <div class="title" style="margin-bottom: 20px; justify-content: left">
        <div class="title_1">
          {{ $t('menu.ShipmentInformation') }}
        </div>
      </div>

      <div>
        <el-table :data="mation[0].poShipments" style="width: 100%" stripe border highlight-current-row
          :cell-style="cellStyle">
          <el-table-column prop="logisticsNumber" :label="$t('menu.ShipmentNo')" width="280"></el-table-column>
          <el-table-column prop="shippedQuantity" :label="$t('menu.Qty')" width="280"></el-table-column>
          <!-- <el-table-column prop="motorName" label="装箱数量"></el-table-column> -->
          <el-table-column prop="shippedTime" :label="$t('menu.ShipmentDate')" width="230">
            <template slot-scope="scope">
              {{ formatDate(scope.row) }}
            </template>
          </el-table-column>
          <!-- <el-table-column prop="quantity" label="备注" width="150"></el-table-column> -->
          <el-table-column>
            <template slot="header" slot-scope="scope">
              <div>{{ $t('menu.Operation') }}</div>
            </template>
            <template slot-scope="scope">
              <div style="display: flex;  width: 100%;">
                <div style="color: #409eff;cursor: pointer;" @click="openDetailsPop">{{ $t('menu.Details') }}</div>
                <!-- <div style="color: #999999;">商业发票</div> -->
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>


 

    <el-dialog :title="$t('menu.DeliveryDetails')" :visible.sync="detailsPop" width="50%">
      <div>
        <el-table :data="mation[0].poParts" style="width: 100%" stripe border highlight-current-row>
          <el-table-column prop="itemNum" :label="$t('menu.ItemNo')" width="80"></el-table-column>
          <el-table-column prop="partNumber" :label="$t('menu.PartCode')" width="180"></el-table-column>
          <el-table-column prop="partName" :label="$t('menu.PartName')"></el-table-column>
          <el-table-column v-if="type == 2" prop="motorName" :label="$t('menu.VehicleModel')"></el-table-column>
           <el-table-column v-if="type == 2" prop="vin" :label="$t('menu.FrameNumber')"></el-table-column>
          <el-table-column prop="quantity" :label="$t('menu.Quantity')" width="130"></el-table-column>
        </el-table>
      </div>
    </el-dialog>



    <el-dialog :title="$t('menu.Tips')" :visible.sync="closePop" width="20%">
      <div style="display: flex;flex-direction: column;align-items: center;justify-content: center;">
        <div style="margin-bottom: 20px;" v-if="inle == 'zh'">确定取消申请?</div>
        <div style="margin-bottom: 20px;" v-if="inle !== 'zh'">Are you sure cancel the application?</div>
        <el-button type="primary" style="width: 120px;" @click="cancel_order">{{ $t('menu.Confirm') }}</el-button>
      </div>
    </el-dialog>
     <el-dialog title="向erp制单" :visible.sync="dialogVisiblea" v-if="dialogVisiblea" width="700px" :before-close="handleClose">
      <div class="ccca" style=" margin: 0 auto">
       <div style="width: 100%;display: flex;    align-items: center;">
        <div style="width: 40%;">
          商户简称：{{ erpform.po.dealerName}}
        </div>
        <div  style="width: 40%;display: flex;align-items: center;">
        
          <div style="width: 150px;">erp商户名称：</div>
           <el-select v-model="erpform.po.address" placeholder="请选择">
            <el-option
              v-for="item in dealist"
              v-if="item.status==1"
              :key="item.id"
              :label="item.erpCompany"
              :value="item.id">
            </el-option>
          </el-select>
        </div>
       </div>
      <div style="width: 100%;display: flex;margin: 10px 0;    align-items: center;">
        <div  style="width: 30%;">
          配件总数：{{ erpform.po.quantity}}
        </div>
        <div  style="width: 30%;">
          订单总额：{{ erpform.po.orderAmount}}{{  erpform.po.currencyType?erpform.po.currencyType:'' }}
        </div>
         <div  style="width: 38%;display: flex;    align-items: center;">
         <div style="width: 60%;">期望发货日期：</div>
         <el-date-picker
      v-model="erpform.po.shippingDate"
      type="date"
      value-format="yyyy-MM-dd"
      placeholder="选择日期">
    </el-date-picker>
        </div>
       </div>
       <div>备注：</div>
       <div style="margin-top: 10px;">
             <el-input
       type="textarea"
       :rows="2"
       placeholder="请输入内容"
       v-model="erpform.po.remarks">
       </el-input>
       </div>
        <div style=" margin: 30px auto" class="er">
          <el-button  type="primary" @click="updata"
            class="er">{{ $t('menu.Confirm') }}</el-button>
       

        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { orderSearch, querytype,listAccType, quxfa,cancelOrder,dealerAreaOfRetailerlist, gbquerytype, exportDetails,myPoUpdate,poAuditOfDealer,submitMyErpOrder } from "../../api/api";

export default {
  data () {
    return {
      closePop: false,
      detailsPop: false,
      dialogVisiblea:false,
      type: 1,
      action: this.$t('menu.CustomerInformation'),
      textarea2: '',
      formInline: {
        title: "",
        status: "",
        startTime: "",
        endTime: "",
        contact: "",
        category: "",
        type: "",
      },
      mation: [],
      ruleForm: {
        name: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: "",
      },
      rules: {
        name: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
          { min: 3, max: 5, message: "长度在 3 到 5 个字符", trigger: "blur" },
        ],
        region: [
          { required: true, message: "请选择活动区域", trigger: "change" },
        ],
      },
      orderNumber: '',
      jsfs: [],
      prList: [],
      hyList: [],
      ckgb: [],
      inle: 'zh',
      tup:'1',
      erpform:{},
      dealist:[],
      acclist:[]    
    };
  },
  created () {
    let a = sessionStorage.getItem('i18n')
     this.tup = sessionStorage.getItem('platform')
    
       sessionStorage.setItem('xqxq','1')
    this.inle = a
    this.type = this.$route.query.type;
    this.orderNumber = this.$route.query.orderNumber
    this.biao();
    this.querytyp()
    this.jg()
    this.accc()
  },
  computed: {
    total () {
      let total = 0
      let data = this.mation[0].poParts
      data.forEach(i => {
        total += i.quantity
      })
      return total
    },
  },
  // watch: {
  //   mation: {
  //     handler (newVal, old) {
  //       console.log(newVal, old)
  //       if (newVal) {
  //         console.log(this.mation[0].po.shippingDate)
  //         this.mation[0].po.shippingDate = this.mation[0].po.shippingDate.replace('T', ' ')
  //       }
  //     }
  //   }
  // },
  methods: {
      ccbaopl(e){
    let a = 0
    if(e>0){
      a=e.toFixed(2)
    }
 
    
    return a
   },
       async accc () {
      let param = new URLSearchParams();
      const { data: res } = await listAccType(param)
    this.acclist  = res.data
         

    },
      ctype(e){
      let a = ''
      this.acclist.forEach(z=>{
           if(z.id==e){
              a=z.currencyName
          }
      })
      return a
    },
     async erpzd(e){
      console.log(e);
        let param={}
        const { data: res } = await dealerAreaOfRetailerlist(param,e.po.dealerId)
        console.log(res);
        
        this.dealist=res.rows
      this.erpform=e
      this.dialogVisiblea=true
    },
      handleClose(){
      this.erpform={}
      this.dialogVisiblea=false
    },
     async updata(){

  let param = this.erpform
  this.dealist.forEach(e=>{
    if(param.po.address==e.id){
      param.po.erpCode=e.erpCode
       param.po.erpName=e.erpCompany
        param.po.erpId=e.id
    }
  })
  param.po.shippingDate=param.po.shippingDate.slice(0, 10)+' 00:00:00'
      const { data: res } = await submitMyErpOrder(param)
      if(res.code=='500'){
 this.$message.error(res.msg)
      }else{
        this.$message.success('成功')
          this.handleClose()
       this.biao()
      }
      
  
    },
    exportDetails () {
      // let id =
      // exportDetails().then (r => {
      //   console.log(r)
      // })
    },
    formatDate (row) {
      let str = row.shippedTime.slice(0, 10)
      return str
    },
    formatHy (item) {
      let str = ''
      this.hyList.forEach(i => {
        if (i.dictValue == item) {
          str = i.dictLabel
        }
        if (i.dictValue == item && this.inle !== 'zh') {
          str = i.dictLabelEn
        }
      })
      return str
    },
    jg () {
      let param = new URLSearchParams();
      querytype(param, 't_po_price_item').then(r => {
        if (r.data.code == 200) {
          this.prList = r.data.data
        }
      })
      querytype(param, 't_po_shipment_method').then(r => {
        if (r.data.code == 200) {
          this.hyList = r.data.data
        }
      })

      querytype(param, 'sys_dealer_area').then(r => {
        if (r.data.code == 200) {
          console.log(123, r)
          this.ckgb = r.data.data
        }
      })
    },
    formatCKBG (val) {
      let str = ''
      this.ckgb.forEach(item => {
        if (item.dictValue == val) {
          if (this.inle == 'zh') {
          str = item.dictLabel
        } else {
         str = item.dictLabelEn
        }
        }

      })
      return str
    },
    formatTime (time) {
      if (time) {
        let str = time.replace('T', ' ')
        return str.slice(0, 10)
      } else {
        let a = ''
        if (this.inle == 'zh') {
          a = '暂无数据'
        } else {
          a = 'No data available yet'
        }
        return a
      }
    },
    async gbquerytype () {
      let param = new URLSearchParams();
      const { data: res } = await gbquerytype(param, 'sys_dealer_area', this.uesrid);
      this.gb = res.data
    },
    cancel_order () {
      let param = new URLSearchParams();
      cancelOrder(
        param,
        this.mation[0].po.id,
        ' '
      ).then(r => {
        if (r.data.code == 200) {
          this.$message.success('取消成功')
          this.closePop = false
          this.$router.back()
        } else {
          this.$message.error('取消失败')
          this.closePop = false

        }
      })
    },
    async querytyp () {
      let param = new URLSearchParams();
      const { data: res } = await querytype(
        param,
        't_po_payment_method'
      );
      this.jsfs = res.data;
    },
    jstype (e) {
      let c = ''
      let a = this.jsfs
      a.forEach(z => {
        if (e == z.dictValue && this.inle == 'zh') {
          c = z.dictLabel
        }
        if (e == z.dictValue && this.inle !== 'zh') {
          c = z.dictLabelEn
        }
      })
      return c
    },
    openDetailsPop () {
      this.detailsPop = true
    },
    formatStatus (status) {
      if (status == -2) {
        return this.$t('menu.Rejected')
      } else if (status == -1) {
        return this.$t('menu.Cancelled')
      } else if (status == 0) {
        return '待支付'
      } else if (status == 1) {
        return this.$t('menu.PendingReview')
      } else if (status == 2) {
        return this.$t('menu.PendingShipment')
      } else if (status == 3) {
        return this.$t('menu.UnderDelivery')
      } else if (status == 4) {
        return this.$t('menu.Completed')
      }else if (status == 5) {
        return this.$t('menu.daizhid')
      }
    },
    gotoEdit (type) {
      if (type == 2) {
        sessionStorage.setItem('name', '修改订单')
        sessionStorage.setItem('pageType', 'edit')
      } else if (type == 1) {

        sessionStorage.setItem('name', this.$t('menu.Reapply'))
      }
      this.$router.push({
        path: "/ordercontenta",
        query: {
          orderNumber: this.orderNumber,
          // type
        },
      })
    },
    cellStyle ({ row, column }) {
      return "height:50px;text-align:center;"
    },
    confirmCancel () {
      this.closePop = false
    },
    openClosePop () {
      this.closePop = true
    },
      async openClosePopaca(){
    
       let param = new URLSearchParams()
       let a = this.mation[0].po.id
      const { data: res } = await quxfa(
        param,
        a,
        ''
      )
      console.log(res.data);
      
      if (res.data == true) {
          this.$message.success('success')
          this.$router.back()
        } else {
          this.$message.error(res.message)
          return
        }
    },
   async openClosePopa(){
    
       let param = new URLSearchParams()
       let a = this.mation[0].po.id
      const { data: res } = await poAuditOfDealer(
        param,
        true,
        a
      )
      console.log(res.data);
      
      if (res.data == true) {
          this.$message.success('审核完成')
          this.$router.back()
        } else {
          this.$message.error(res.message)
          return
        }
    },
    async openClosePopb(){
         let param = new URLSearchParams()
       let a = this.mation[0].po.id
      const { data: res } = await poAuditOfDealer(
        param,
        false,
        a
      )
      console.log(res.data);   
      if (res.data == true) {
          this.$message.success('拒绝完成')
          this.$router.back()
        } else {
          this.$message.error(res.message)
          return
        }
     },
    async biao () {
      let param = new URLSearchParams();
      let orderNumber = this.orderNumber
      const { data: res } = await orderSearch(param, orderNumber);
      console.log(res)
    
      this.mation=[]
      this.mation.push(res.data)
      // this.totale = res.data.total;
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          alert("submit!");
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm (formName) {
      this.$refs[formName].resetFields();
    },
    act (e) {
      this.action = e;
    },
    handleEdit (index, row) {
      this.$router.back()
    },
    goBack () {
      this.$router.back()
    }
  },
};
</script>

<style lang="less" scoped>
.diadin {
  width: 100%;
  min-height: 80vh;
  background-color: #fff;
  padding: 20px;
  padding-left: 0;
}
.contddt{
  display: flex;
  justify-content: space-between;
  margin: 20px;
  font-size: 20px;
}
.title {
  width: 100%;
  border-bottom: 1px solid #f2f2f2;
  padding: 20px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.title_1 {
  padding-left: 15px;
  border-left: 5px solid #409eff;
}

.cont {
  display: flex;
  flex-wrap: wrap;

  padding-bottom: 30px;
}

.contbox {

  width: 30%;
  margin-top: 30px;
}

.contbox1 {

  width: 30%;
}


/deep/.el-form-item__content {
  width: 100%;
}

/deep/.el-select {
  width: 95%;
}

/deep/.el-table th.is-leaf {
  text-align: center;
  background-color: #d7d7d7;
}

.actio {
  color: #409eff;
}

.product-box {
  margin-top: 20px;
  display: flex;

  div {
    margin-right: 20px;
  }

  .daochu {
    color: #409eff;
  }
}

.btn-box {
  margin-top: 80px;
  display: flex;

  div {
    margin-right: 20px;
  }

  .blue {
    border: 0 !important;
    background-color: #409eff;
    color: #fff !important;
  }

  .btn {
    cursor: pointer;
    border: 1px solid #eee;
    width: 100px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
  }

}
.conttitle {
  width: 180px;
  text-align: left;
  margin-bottom: 10px;
  color: #909399;
}
/deep/.el-table th.is-leaf {
  text-align: left;
}

/deep/.el-table__row {
  td {
    text-align: left !important;
  }
}

.popbtn {
  width: 200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.cell-style {
  display: flex;
  align-items: center;
  justify-content: center;
}

.agian {
  margin-top: 20px;
}
</style>